import { render, staticRenderFns } from "./ContactDeleteProvider.vue?vue&type=template&id=1e898a38&scoped=true&"
import script from "./ContactDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./ContactDeleteProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e898a38",
  null
  
)

export default component.exports